export default async function GetDropdownOptionsByIdsApi(ids = []) {
  let res = "";
  if (!ids || ids.length === 0) return { success: true, data: {} };

  try {
    const token = "Bearer " + localStorage.getItem("authToken");
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: token,
      },
    };
    const idsParam = ids.join(",");
    await fetch(
      `${process.env.REACT_APP_API_URL}v1/plan-attributes/dropdown-options?ids=${encodeURIComponent(idsParam)}`,
      requestOptions
    )
      .then((response) => response.json())
      .then((response) => {
        res = response;
      })
      .catch((error) => {
        console.error("Error getting dropdown options: ", error);
        res = error;
      });
  } catch (error) {
    console.error(error);
    res = error;
  }

  return res;
}
